import { render, staticRenderFns } from "./Paso3.vue?vue&type=template&id=8422fcc0&scoped=true"
import script from "./Paso3.vue?vue&type=script&lang=js"
export * from "./Paso3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8422fcc0",
  null
  
)

export default component.exports